// ShapeGeoBuilder and umlConst are both re-exported in the @jxUml barrel
// (UmlWorkspace/index.js) together with ShapeGeoBuilder itself — import by
// relative path here to avoid a self-referential cycle through that barrel.
import umlConst from './UmlConsts.js';

/**
 * Effective height of a shape for geometry purposes (package containment,
 * connector anchoring). A collapsed shape only renders its header row, so
 * its on-screen height is a fixed collapsed-header height (which one
 * depends on shape.kind — package vs class have different header rows),
 * not the full stored shape.h. Shapes without a `.collapsed` field set to
 * true are unaffected — falls through to shape.h unchanged.
 */
class ShapeGeoBuilder {
    static effectiveHeight(shape) {
        if (!shape.collapsed) return shape.h;
        return shape.kind === 'package' ? umlConst.PACKAGE_COLLAPSED_HEADER_HEIGHT : umlConst.CLASS_COLLAPSED_HEADER_HEIGHT;
    }
}

export default ShapeGeoBuilder;
